import { SalesReturnStatusEnum } from "./return-status-enum";

export const salesReturnStatusLabels = Object.freeze({
  [SalesReturnStatusEnum.NONE]: "Belum Diretur",
  [SalesReturnStatusEnum.PARTIALLY_RETURNED]: "Sebagian Diretur",
  [SalesReturnStatusEnum.FULLY_RETURNED]: "Sudah Diretur",
});
